import { Locales } from 'types/locale';

export const LOCALE_DEFAULT = Locales.Pl;

export const LOCALES_MAP = [{
    key: Locales.Pl,
    name: 'PL',
}];
